<template>
  <div v-loading="fullscreenLoading" element-loading-background="rgba(255, 255, 255, 0.4)">
    <el-form
      :label-position="left"
      :inline="true"
      size="mini"
      label-width="85px"
      :model="formInline"
      class="demo-form-inline"
      :rules="rules"
    >
      <el-row>
        <el-form-item label="交易单号">
          <el-input v-model="formInline.tradeNo"></el-input>
        </el-form-item>
        <el-form-item label="订单编号">
          <el-input v-model="formInline.id"></el-input>
        </el-form-item>
        <el-form-item label="支付方式">
          <el-select clearable v-model="formInline.payType" placeholder="请选择">
            <el-option v-for="(v,k) in payTypeArr" :key="k" :label="v" :value="k"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select clearable v-model="formInline.status" placeholder="请选择">
            <el-option v-for="(v,k) in options" :key="k" :label="v" :value="k"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付时间">
          <el-date-picker
            v-model="value7"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-button size="mini" type="primary" @click="search" icon="el-icon-search">搜索</el-button>
        <div style="color:#606266">
          <span>实收金额:<span style="color:red">{{totalPayAmt}}</span>元</span>
          <span style="margin-left:15px;">订单总金额:<span style="color:red">{{totalOrderAmt}}</span>元</span>
        </div>
      </el-row>
    </el-form>
    <el-table
      :row-class-name="tableRowClassName"
      ref="multipleTable"
      :data="tableData3"
      size="mini"
      tooltip-effect="dark"
      style="width: 100%"
      header-cell-class-name="cen"
      cell-class-name="cen"
    >
      <el-table-column label="序号" type="index" :index="indexMethod" width="55px"></el-table-column>
      <el-table-column prop="id" label="订单编号" width="155px"></el-table-column>
      <el-table-column prop="tradeNo" label="交易单号" width="155px"></el-table-column>
      <el-table-column prop="payAmt" label="订单金额">
        <template slot-scope="scope">{{(scope.row.orderAmt/100).toFixed(2)}}元</template>
      </el-table-column>
      <el-table-column prop="payAmt" label="实付金额">
        <template slot-scope="scope">{{(scope.row.payAmt/100).toFixed(2)}}元</template>
      </el-table-column>
      <el-table-column label="支付方式">
        <template slot-scope="scope">{{payTypeArr[scope.row.payType]}}</template>
      </el-table-column>
      <el-table-column label="订单状态">
        <template slot-scope="scope">{{options[scope.row.status]}}</template>
      </el-table-column>
      <el-table-column prop="rowCrtTs" label="下单时间" width="147px">
        <template slot-scope="scope">{{scope.row.rowCrtTs | formatDate("yyyy-MM-dd hh:mm:ss")}}</template>
      </el-table-column>
      <el-table-column prop="payTime" label="支付时间" width="147px">
        <template slot-scope="scope">{{scope.row.payTime | formatDate("yyyy-MM-dd hh:mm:ss")}}</template>
      </el-table-column>
      <el-table-column prop="expressTime" label="配货时间" width="147px">
        <template slot-scope="scope">{{scope.row.expressTime | formatDate("yyyy-MM-dd hh:mm:ss")}}</template>
      </el-table-column>
      <el-table-column label="收货人" prop="historyAddress.consigneeName"></el-table-column>
      <el-table-column label="操作" width="170px">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="show(scope.row)">详情</el-button>
          <el-button
            size="mini"
            type="primary"
            @click="Delivery(scope.row.id,scope.row.status)"
            v-if="scope.row.status==2"
          >配送</el-button>
        </template>
      </el-table-column>
    </el-table>
    <br />
    <div class="block">
      <el-pagination
        class="right"
        @current-change="handleCurrentChange"
        :current-page="formInline.page"
        :page-size="10"
        layout="total, prev, pager, next, jumper"
        :total="page.total"
      ></el-pagination>
    </div>

    <el-dialog title="订单详情" :visible.sync="dialogTableVisible_" width="700px">
      <detaile @close="dialogTableVisible_=false" v-if="dialogTableVisible_" :id="id"></detaile>
    </el-dialog>
  </div>
</template>

<script>
import Eve from "../../../components/common/emit.js";
import { baseurl } from "../../../base.js";
import detaile from "./detaile.vue";
const TIME_COUNT = 30;
export default {
  components: { detaile },
  created() {
    Eve.$on("orderList", () => {
      this.load();
    });
    this.load();
    //  let date = new Date();
    //     let datE =
    //       date.getFullYear() +
    //       "-" +
    //       (date.getMonth() + 1) +
    //       "-" +
    //       date.getDate();
    //     this.formInline.startTime = datE;
    //     this.formInline.endTime = datE;
    //     this.value7=[datE,datE]
  },
  data() {
    return {
      rules: {},
      left: "left",
      dialogTableVisible_: false,
      gridData: [],
      receiptMemo: "",
      payTypeArr: {
        0: "微信",
        1: "支付宝"
      },
      options: {
        0: "待支付",
        2: "支付成功",
        3: "支付失败",
        4: "已关闭",
        6: "已配送"
      },
      value7: [],
      fullscreenLoading: false,
      page: {
        total: 0
      },
      tableData3: [],
      formInline: {
        tradeNo: "",
        startTime: "",
        id: "",
        endTime: "",
        page: 1,
        status: "",
        payType: "",
        size: 10
      },
      id: {},
      objid: "",
      totalOrderAmt: "",
      totalPayAmt: ""
    };
  },
  watch: {},
  methods: {
    show(item) {
      this.dialogTableVisible_ = true;
      this.id = item.id;
    },
    indexMethod(index) {
      return (this.formInline.page - 1) * 10 + index + 1;
    },
    tableRowClassName({ row, rowIndex }) {},
    handleCurrentChange(index) {
      this.formInline.page = index;
      this.load();
    },
    load() {
      if (!this.value7) {
        this.formInline.startTime = null;
        this.formInline.endTime = null;
      } else {
        this.formInline.startTime = this.value7[0];
        this.formInline.endTime = this.value7[1];
      }
      this.fullscreenLoading = true;
      this.$http
        .post(
          `/w/order/s?pageNumber=${this.formInline.page}&pageSize=${this.formInline.size}`,
          this.formInline
        )
        .then(data => {
          this.fullscreenLoading = false;
          this.tableData3 = data.data;
          this.page.total = data.pageable.totalElements;
          this.totalOrderAmt = (data.extendData.totalOrderAmt / 100).toFixed(2);
          this.totalPayAmt = (data.extendData.totalPayAmt / 100).toFixed(2);
        })
        .catch(error => {
          this.fullscreenLoading = false;
        });
    },
    Delivery(id, status) {
      this.$confirm("是否确认配送?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.fullscreenLoading = true;
          this.$http
            .post(`/w/order/status/${id}`, { status: status })
            .then(data => {
              this.fullscreenLoading = false;
              this.$message({
                type: "success",
                message: "修改成功"
              });
              this.load();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    search() {
      this.formInline.page = 1;
      this.load();
    }
  }
};
</script>

<style scoped>
.verification {
  width: 80px;
  height: 30px;
  background: #409eff;
  font-size: 12px;
  border-radius: 3px;
  line-height: 30px;
  text-align: center;
  color: white;
  display: inline-block;
  margin: 10px 0;
}
.el-form-item__label {
  text-align: left !important;
}
.po {
  cursor: pointer;
}
.po:hover {
  color: red;
}
/* .hide {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
} */
.cen {
  text-align: center;
}
.right {
  text-align: right;
}
.textzin {
  width: 300px;
  height: 120px;
  border-radius: 5px;
  border: 1px solid #c0c4cc;
}
.h100 {
  width: 130px;
}
</style>


// WEBPACK FOOTER //
// src/view/page/orderAdmin/orderAdmin.vue